import React from 'react';
import EventEmitter from 'events';

import util from '../tools/util';
import UserStore from './user_store';

export default {
  init,
  isReady,
  useOrgList,
  fetchOrg,
};

const g_listOrgMap = new Map<number, any>();

const g_eventEmitter = new EventEmitter();
const CHANGE_EVENT = 'change';
function _emit(...args) {
  g_eventEmitter.emit(CHANGE_EVENT, ...args);
}
function init(done) {
  done?.();
}
function isReady() {
  return true;
}
function _getOrgList(org_id: number) {
  return g_listOrgMap.get(org_id);
}
function _subscribe(callback: any) {
  g_eventEmitter.on(CHANGE_EVENT, callback);
  return () => {
    g_eventEmitter.removeListener(CHANGE_EVENT, callback);
  };
}
export function useOrgList(org_id: number) {
  const _get = React.useCallback(() => _getOrgList(org_id), [org_id]);
  return React.useSyncExternalStore(_subscribe, _get);
}
function fetchOrg(org_id: number, done?: (err: any) => void) {
  const opts = {
    url: `/admin/1/org/${org_id}/s3_bucket`,
  };
  UserStore.get(opts, (err, body) => {
    if (err) {
      util.errorLog('S3BucketStore.fetch: err:', err);
    } else if (body) {
      const old = g_listOrgMap.get(org_id);
      if (!util.deepEqual(old, body.s3_bucket_list)) {
        g_listOrgMap.set(org_id, body.s3_bucket_list);
        _emit('update');
      }
    }
    done?.(err);
  });
}
